import { getThemeBasedIconColor } from '../../config/theme/getThemeBasedIconColor';
import { COUNTRY } from '@mango-engineering/maknet-client-sdk/lib/shop/types';

interface Props {
  country: COUNTRY;
}

export const SearchTopPicksIconNew = ({ country }: Props) => {
  const useGradient = country === COUNTRY.THAILAND || country === COUNTRY.MYANMAR;
  const colors = getThemeBasedIconColor(country);

  return (
    <svg
      width={16}
      height={19}
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x={0.0000610352} y={3} width={16} height={16} rx={8} fill={colors.background} />
      <g filter="url(#a)">
        <path
          d="M7.84 1.722c.446-.01.83.053 1.168.365l.04.038c.25.26.325.599.333.945-.022.332-.191.636-.333.93l-.078.164-.024.05a.687.687 0 0 0-.038.545c.072.155.18.254.331.328.11.039.22.034.334.033h.082a129.557 129.557 0 0 1 .895.002 221.185 221.185 0 0 1 1.107.003c.686.001 1.237.097 1.753.589.328.345.499.817.512 1.29a2.38 2.38 0 0 1-.05.402c-.035.189-.077.376-.12.562l-.026.113-.069.302-.043.19a748.658 748.658 0 0 1-.417 1.808 111.178 111.178 0 0 0-.165.72c-.152.67-.493 1.315-1.083 1.7-.022.012-.044.026-.066.04l-.079.047a2.258 2.258 0 0 1-1.201.318h-.222l-.16.001-.524.001h-.18l-.753.002H8.52a340.97 340.97 0 0 0-1.589.003 136.125 136.125 0 0 0-1.033.001c-.536.004-.989-.088-1.41-.446l-.058-.045c-.357-.3-.55-.783-.593-1.236a5.52 5.52 0 0 1-.004-.237V10.948a462.596 462.596 0 0 0-.002-.902V9.008a463.672 463.672 0 0 0-.002-1.658 185.137 185.137 0 0 0-.001-1.077c-.004-.798.192-1.316.756-1.89l.13-.132.072-.072c.078-.08.157-.158.235-.236l.082-.082a534.37 534.37 0 0 1 1.165-1.17 71.2 71.2 0 0 0 .497-.499c.313-.31.637-.455 1.075-.47Z"
          fill={useGradient ? 'url(#b)' : colors.primary}
        />
      </g>
      <g filter="url(#c)">
        <path
          d="M2.855 5.339c.12.069.19.171.232.3.003.04.004.08.004.12v.745l.001.568v.354a1458.45 1458.45 0 0 1 .001 1.236v.064a762.186 762.186 0 0 0 .002 2.078 277.395 277.395 0 0 0 .001 1.351V12.516c0 .157-.011.271-.12.393-.134.11-.236.16-.412.156a.5.5 0 0 1-.32-.175.503.503 0 0 1-.105-.32v-.484l-.001-.258a237.54 237.54 0 0 1 0-.918v-.178a1012.619 1012.619 0 0 1-.001-2.137A654.214 654.214 0 0 1 2.136 6.2V5.842c0-.172.022-.279.137-.412a.526.526 0 0 1 .582-.091Z"
          fill={useGradient ? 'url(#d)' : colors.primary}
        />
      </g>
      <defs>
        {useGradient && (
          <linearGradient
            id="b"
            x1="3.828"
            y1="7.468"
            x2="13.922"
            y2="7.468"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={colors.primary} />
            <stop offset="1" stopColor={colors.secondary} />
          </linearGradient>
        )}
        {useGradient && (
          <linearGradient
            id="d"
            x1="2.135"
            y1="9.177"
            x2="3.097"
            y2="9.177"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={colors.primary} />
            <stop offset="1" stopColor={colors.secondary} />
          </linearGradient>
        )}
        <filter
          id="a"
          x="1.828"
          y=".721"
          width="14.094"
          height="15.493"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.964583 0 0 0 0 0.270102 0 0 0 0 0.292033 0 0 0 0.15 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19634_12914"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_19634_12914"
            result="shape"
          />
        </filter>
        <filter
          id="c"
          x=".135"
          y="4.289"
          width="4.961"
          height="11.777"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.964583 0 0 0 0 0.270102 0 0 0 0 0.292033 0 0 0 0.15 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19634_12914"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_19634_12914"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
